// Advertiser Disclosure Popup
const openLink = document.querySelector('.open-popup');
const closeLink = document.querySelector('.close-popup');
const closeX = document.getElementById('closeX');
const popup = document.getElementById('popup');

openLink.addEventListener('click', (e) => {
  e.preventDefault();
  popup.style.display = 'flex';
});

closeLink.addEventListener('click', (e) => {
  e.preventDefault();
  popup.style.display = 'none';
});

closeX.addEventListener('click', (e) => {
  e.preventDefault();
  popup.style.display = 'none';
});

// Form Success Message
document.addEventListener("DOMContentLoaded", function () {
  const form = document.getElementById("contact_form");

  form.addEventListener("submit", function () {
    alert("Thank you! Your submission has been received.");
  });
});